module.exports = __webpack_public_path__ + "static/media/dumbbell.f08376c3.svg";